import { AnyAction } from "redux";

import {RemoveToasts, AddToasts, ShowLoader, SetError,ModalError } from '../actions/actionTypes';
import { updateObject } from '../../services/utilService';

const initialState = {    
    toasts: [],
    isError: false,
    isLoading: false,
    modalError:null,
};

const addToasts = (state: any, action: any) => {
    let toasts = [...state.toasts];
    toasts.push(action.payload);
    return updateObject(state, { toasts });
}

const removeToasts = (state: any, action: any) => {
    let toasts = [...state.toasts];
    toasts.splice(action.payload, 1);
    return updateObject(state, { toasts });
}

const showLoader = (state: any, action: any) => {
    return updateObject(state, { isLoading : action.payload });
}

const commonReducer = (state = initialState, action: AnyAction) => {
    switch(action.type) {
        case AddToasts: return addToasts(state, action);
        case RemoveToasts: return removeToasts(state, action);
        case ShowLoader: return showLoader(state, action);
        case SetError: return updateObject(state, {isError : action.payload});
        case ModalError: return updateObject(state, {modalError : action.payload});
        default: return state;
    } 
}

export default commonReducer;